import searchContent from '@/utils/searchContent';

import StateFilingGuide from './[slug]';

export async function getStaticProps() {
  const response = await searchContent({
    fieldOptionsToReturn: ['States'],
  });
  const { options } = response;
  return {
    props: {
      states: options.States,
      statecode: 0,
    },
  };
}
export default StateFilingGuide;
